import React, {memo} from 'react';
import {ModuleTabularPage} from "../../components";
import {AdminModules, AdminReqUrls} from "../../config/AdminConfig";

const LinkPage = memo(() => {
    return (<ModuleTabularPage
        moduleName={AdminModules.Links}
        fetchRecordsUrl={AdminReqUrls.admin__link__mainPage_fetch_recordList}
    />)
});
export default LinkPage;
